import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function TechGearReviewedLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="44" height="29" viewBox="0 0 44 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M22.1239 7.86292L29.1829 1.00108L43.25 14.7215L29.1829 28.4008L22.1239 21.5833L29.1829 14.7237L22.1239 7.86292ZM22.1239 7.86292L15.1137 14.7237L22.125 21.5823L15.1158 28.3986L1 14.7226L15.1137 1L22.1239 7.86292Z"
          stroke="white"
          strokeWidth="1.08333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <span>Tech Gear Reviewed</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 top-0 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
